import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IProfile } from '../models/profile';

export interface IChangePasswordRequest{
  password: string,
  newPassword: string,
  confirmNewPassword: string
}

@Injectable({
  providedIn: 'root'
})
export class PersonalService {

  constructor(private http: HttpClient) {}

  getPermissionOfCurrentUser(){
    return this.http.get<string[]>(
      `${environment.baseUrl}/personal/permissions`
    )
  }

  getProfileOfCurrentUser() {
    return this.http.get<IProfile>(
      `${environment.baseUrl}/personal/profile`
    )
  }

  changePassword(request: IChangePasswordRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/personal/change-password`,
      request
    )
  }
}
